import React, { Component } from 'react';
import '../../assets/css/video.css'
import ReactPlaceholder from 'react-placeholder';
//image
import videoIcon from '../../assets/images/video.svg';
import {
    _clearInterval,
    _startInterval,
    cancelFullScreen,
    requestFullScreen,
    startVideoStream
} from "../../util/broadcast/countdown";
import * as actions from "../../actions";
import { connect } from "react-redux";
import { vuepayAlert } from "../../util/utility";
import { getEncryptedIdForBroadcaster } from "../../util/broadcast_util";
// import {getData, LOGIN} from "../../util/storage";
import OT from '@opentok/client';
import NetworkTest from 'opentok-network-test-js';
import { TOKBOX_APIKEY } from "../../util/constants";

class Countdown extends Component {

    constructor(props) {
        super(props);
        this.state = {
            api_key: TOKBOX_APIKEY,
            isVideoPlaying: false,
            countdown: -1,
            session_id: null,
            token: null,
            broadcast_id: null,
            countdownMessage: 'Waiting to get video access...',
            isNetworkTesting: false
        };

        //all the functions used in this component should be listed here for better documentation
        this.startCountdown = this.startCountdown.bind(this);
        this.startVideo = this.startVideo.bind(this);
        this.stopVideo = this.stopVideo.bind(this);
        this.requestFullScreen = this.requestFullScreen.bind(this);
        this.cancelFullScreen = this.cancelFullScreen.bind(this);
    }

    componentDidMount() {

        startVideoStream((stream) => {
            if (stream === undefined || stream === null) {
                vuepayAlert("error", "Audio/Video Permissions denied.");
                this.props.history.push("/broadcaster/create/broadcast")
                return
            }
            else {
                // getData(LOGIN)
                //     .then((data) => {
                //         if (!isEmpty(data)) {
                //             this.props.createTestBroadcast(data.token, data.api_token)
                //         }
                //     })
                this.startVideo(stream);
            }

        });

        //hide the leftbar
        this.props.hideLeftBar();
        this.props.hideSearchBar() //hide the Search bar
    }

    componentWillUnmount() {
        this.setState({
            isVideoPlaying: false,
            countdownMessage: 'Please wait, you will be navigated soon to broadcast'
        }, () => {
            _clearInterval();
            this.stopVideo()
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps.hasOwnProperty("broadcast") &&
            nextProps.broadcast.hasOwnProperty("payload") &&
            nextProps.broadcast.payload !== null &&
            nextProps.broadcast.payload.hasOwnProperty("data") &&
            nextProps.broadcast.payload.data.hasOwnProperty("session_id") &&
            nextProps.broadcast.payload.data.hasOwnProperty("token")) {

            let broadcastData = nextProps.broadcast.payload.data;
            this.props.resetCreateTestBroadcast();

            if (broadcastData.hasOwnProperty("session_id") &&
                broadcastData.hasOwnProperty("token")) {

                const ref = this;

                const otNetworkTest = new NetworkTest(OT, {
                    apiKey: this.state.api_key, // Add the API key for your OpenTok project here.
                    sessionId: broadcastData.session_id,
                    token: broadcastData.token
                });


                otNetworkTest.testConnectivity().then((results) => {
                    //console.log('OpenTok connectivity test results', results);
                    //console.log(results.success)
                    ref.setState({
                        isNetworkTesting: true
                    }, () => {
                        startVideoStream((stream) => {
                            if (stream === undefined) {
                                vuepayAlert("error", "Audio/Video Permissions denied.");
                                this.props.history.push("/broadcaster/create/broadcast")
                            }
                            else {
                                this.startVideo(stream);
                            }

                        });
                    })
                    if (results.success) {
                        otNetworkTest.testQuality(function updateCallback(stats) {
                            //console.log('intermediate testQuality stats', stats);
                            ref.setState({
                                countdownMessage: 'Please wait, while we test your network connectivity...'
                            })
                        }).then((results) => {
                            // This function is called when the quality test is completed.
                            //console.log('OpenTok quality results', results);
                            let publisherSettings = {};
                            if (results.video.reason) {
                                //console.log('Video not supported:', results.video.reason);
                                publisherSettings.videoSource = null; // audio-only
                            } else {
                                publisherSettings.frameRate = results.video.recommendedFrameRate;
                                publisherSettings.resolution = results.video.recommendedResolution;
                            }
                            if (!results.audio.supported) {
                                //console.log('Audio not supported:', results.audio.reason);
                                publisherSettings.audioSource = null;
                                // video-only, but you probably don't want this -- notify the user?
                            }

                            // Publish to the "real" session, using the publisherSettings object.
                            if (results.video.packetLossRatio > 0.03) {
                                vuepayAlert("error", "Poor connectivity...We recommend a good internet connection to maintain a stable video connection with your viewers.");
                                this.props.history.push("/broadcaster/create/broadcast")
                            } else {
                                ref.setState({
                                    countdownMessage: 'Network test went ok, navigating to broadcast screen.'
                                })
                                const broadcastID = getEncryptedIdForBroadcaster(this.state.broadcast_id);
                                this.props.history.push(`/broadcaster/start/broadcast?session_id=${this.state.session_id}&broadcast_id=${broadcastID}&token=${this.state.token}`, {
                                    session_id: this.state.session_id,
                                    broadcast_id: this.state.broadcast_id,
                                    token: this.state.token
                                })
                            }

                        }).catch((error) => {
                            vuepayAlert("error", "Broadcasting error. Please try again later.");
                            this.props.history.push("/broadcaster/create/broadcast")
                            //console.log('OpenTok quality test error', error);
                        });
                    }
                    else {
                        vuepayAlert("error", "Poor connectivity...We recommend a good internet connection to maintain a stable video connection with your viewers.");
                        this.props.history.push("/broadcaster/create/broadcast")
                    }

                }).catch(function (error) {
                    vuepayAlert("error", "Connectivity error. Please try again.");
                    this.props.history.push("/broadcaster/create/broadcast")
                    //console.log('OpenTok connectivity test error', error);
                });
            }
        }

        if (nextProps.hasOwnProperty("tokbox") &&
            nextProps.tokbox.hasOwnProperty("payload") &&
            nextProps.tokbox.payload.hasOwnProperty("time_to_start_the_broadcast") &&
            this.state.countdown === -1
        ) {

            this.setState({
                session_id: nextProps.tokbox.payload.session_id,
                token: nextProps.tokbox.payload.token,
                broadcast_id: nextProps.tokbox.payload.id,
                countdown: nextProps.tokbox.payload.time_to_start_the_broadcast
            })
        }
    }

    navigateToStartBroadcastPage = () => {
        const broadcastID = getEncryptedIdForBroadcaster(this.state.broadcast_id);
        this.props.history.push(`/broadcaster/start/broadcast?session_id=${this.state.session_id}&broadcast_id=${broadcastID}&token=${this.state.token}`, {
            session_id: this.state.session_id,
            broadcast_id: this.state.broadcast_id,
            token: this.state.token
        })
    }

    startVideo = (stream) => {
        // Grab elements, create settings, etc.
        if (stream && stream !== null) {
            const video = document.getElementById('video');
            video.srcObject = stream;
            video.play();
            setTimeout(() => {
                this.setState({
                    isVideoPlaying: true
                }, () => {
                    if (!this.state.isNetworkTesting) {
                        this.startCountdown((this.state.countdown === -1) ? 10 : this.state.countdown);
                    }

                })
            }, 1000);
        }

    }

    startCountdown = (countTillInSeconds) => {
        this.setState({
            isVideoPlaying: false,
            countdownMessage: 'Please wait, you will be navigated soon to broadcast'
        }, () => {
            _clearInterval();
            this.stopVideo();
            this.navigateToStartBroadcastPage()
        })

        //removed the below code as want to start the broadcast immediately
        //
        // _startInterval(countTillInSeconds, (duration, durationUI) => {
        //     if (duration === 0) {
        //         this.setState({
        //             isVideoPlaying: false,
        //             countdownMessage: 'Please wait, you will be navigated soon to broadcast'
        //         }, () => {
        //             _clearInterval();
        //             this.stopVideo();
        //             this.navigateToStartBroadcastPage()
        //         })
        //     } else {
        //         this.setState({
        //             countdownMessage: durationUI
        //         })
        //     }
        // })
    };

    stopVideo = () => {
        const video = document.getElementById('video');
        video.pause();
        video.src = "";
    }

    requestFullScreen = () => {
        //const video = document.getElementById('video');
        const video = document.getElementsByClassName('video-container')[0];
        requestFullScreen(video);
    };

    cancelFullScreen = () => {
        //const video = document.getElementById('video');
        const video = document.getElementsByClassName('video-container')[0];
        cancelFullScreen(video);
    };


    render() {
        return (
            <div>
                <div>
                    <main role="main" className="">
                        <div className="broadcast-container broadcasting">
                            <div className="row">
                                <div className="col-xl-12 col-lg12">
                                    <div className="title-container mb-2">
                                        <div>
                                            <p>
                                                {
                                                    this.state.countdownMessage
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-12 col-lg12">
                                    <div className="video-wrapper" style={{ height: 456 }}>
                                        <div className="video-container">
                                            <ReactPlaceholder
                                                showLoadingAnimation={true}
                                                type={'rect'}
                                                ready={this.state.isVideoPlaying}
                                                color='#E0E0E0'
                                                style={{ width: 'calc(100vw)', height: 'calc(100vh)' }}>
                                                <div></div>
                                            </ReactPlaceholder>
                                            <img src={videoIcon} alt={"video icon"} className="video-play-icon" />
                                            {
                                                this.state.isVideoPlaying &&
                                                <div className="btn-controls fullscreen"
                                                    onClick={this.requestFullScreen} />
                                            }

                                            <video width="640" height="480" id="video" controls="false">
                                                Your browser does not support the video tag.
                                            </video>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        tokbox: state.tokbox,
        broadcast: state.broadcast,
    };
}

export default connect(mapStateToProps, actions)(Countdown);